/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { AppInfoDto } from './AppInfoDto';
import type { CreatedUserDto } from './CreatedUserDto';
import type { EnvVar } from './EnvVar';
import type { PostgresConfigDto } from './PostgresConfigDto';
import type { TopUpDto } from './TopUpDto';
import type { ValidatorDbConfigDto } from './ValidatorDbConfigDto';

export type ValidatorResponseDto = {
    appInfoCantonNameService?: AppInfoDto;
    appInfoValidator?: AppInfoDto;
    appInfoWallet?: AppInfoDto;
    application: string;
    applicationCantonNameServer: string;
    applicationWallet?: string;
    contactPoint?: string;
    createdUser: CreatedUserDto;
    customAuth?: boolean;
    databaseStorage?: string;
    disabledWallet?: boolean;
    envVars?: Array<EnvVar>;
    exposeLedgerApi?: boolean;
    imageRepo: string;
    imageTag: string;
    immutable?: boolean;
    jsonApiAddress?: string;
    ledgerApiAddress?: string;
    validatorApiAddress?: string;
    migrationId?: string;
    migrationMigrating?: boolean;
    name: string;
    onboardingSecretName?: string;
    participant: string;
    participantIdentitiesDumpSecretName?: string;
    participantInfo?: AppInfoDto;
    partyId?: string;
    phase?: ValidatorResponseDto.phase;
    postgresPassword?: string;
    postgresUser: string;
    privateJsonApi?: boolean;
    scanAddress?: string;
    storageSize?: string;
    disableProbes?: boolean;
    topUp?: TopUpDto;
    databaseConfig?: ValidatorDbConfigDto;
    postgresConfig?: PostgresConfigDto;
};

export namespace ValidatorResponseDto {

    export enum phase {
        COMPLETED = 'COMPLETED',
        PENDING = 'PENDING',
        RUNNING = 'RUNNING',
    }


}

